import React from 'react';
import { useSelector } from 'react-redux';

import LabelElementPillsContainer from '../../../labels/LabelElementPillsContainer';
import { selectLabelsByIds } from '../../../labels/labelSelectors';
import { length } from '../../../../../common/utils/immutableHelper';
import { TaskLabelData } from '../taskPillsTypes';

import './TaskLabelPills.scss';

const TaskLabelPills: React.FC<TaskLabelData> = ({ labelIds, element, filterQuery }) => {
    const elementLabels = useSelector(selectLabelsByIds(labelIds));
    const labelCount = length(elementLabels);

    if (!labelCount) return null;

    return (
        <div className="TaskLabelPills">
            {elementLabels && (
                <LabelElementPillsContainer
                    labels={elementLabels}
                    size="xs"
                    element={element}
                    filterQuery={filterQuery}
                />
            )}
        </div>
    );
};

export default TaskLabelPills;
